import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7e5c97fe&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./detail.vue?vue&type=style&index=1&id=7e5c97fe&prod&lang=scss&scoped=true"
import style2 from "./detail.vue?vue&type=style&index=2&id=7e5c97fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5c97fe",
  null
  
)

export default component.exports